var map = {
	"./CompactHeader.tsx": 45058,
	"./Footer.tsx": 68649,
	"./Header.tsx": 38382,
	"./HomePage.tsx": 63612,
	"./Layout.tsx": 79016,
	"./SharedContent.tsx": 7110,
	"./SignInPage.tsx": 18029,
	"./UnhandledErrorModal.tsx": 70052,
	"./VariantRootPage.tsx": 19226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32507;